import React from "react";
import "./App.css";
import { BrowserRouter as Router, Route } from "react-router-dom";
import Home from "./pages/Home";
import Login from "./pages/Login";
import SignUp from "./pages/SignUp";
import { AuthProvider } from "./Auth";
import PrivateRoute from "./PrivateRoute";
import FileUpload from "./pages/Fileupload";
import History from "./pages/History";
import Aitest from "./pages/AItest";
import About from "./pages/about";
import Brugada from "./pages/Brugada";
import Hardware from "./pages/Hardware";
import Read from "./pages/Read";
import Use from "./pages/Use";
import ECGs from "./pages/ECG"
import Data1 from "./pages/Data1"
import Data2 from "./pages/Data2"
import Data3 from "./pages/Data3"
import Data4 from "./pages/Data4"
import Form from "./pages/Form"
import Quiz from "./pages/Quiz"
import  SuggestionHealthy from "./pages/SuggestionHealthy"
import  SuggestionHospital from "./pages/SuggestionHospital"
import SuggestionBad from "./pages/SuggestionBad"
import Telemedicine from "./pages/Telemedicine"
import HardwareHistory from "./pages/HardwareHistory"
import HardwareManual from "./pages/HardwareManual"
import Choose from "./pages/choose"
import SuggestionHospital2 from "./pages/SuggestionHospital2"
import T1 from "./pages/1"
import T2 from "./pages/2"
import T3 from "./pages/3"
import T4 from "./pages/4"
import T5 from "./pages/5"
import T6 from "./pages/6"
import T7 from "./pages/7"
import T8 from "./pages/8"
import T9 from "./pages/9"
import T10 from "./pages/10"
import T11 from "./pages/11"
import T12 from "./pages/12"
import Tele from "./pages/Telemedicinedemo1"
import D1 from "./pages/1_1"
import DateTimePicker from "./pages/demo"
import HomeEN from "./pages_EN/Home_en"
import aboutEN from "./pages_EN/about_en"
import chooseEN from "./pages_EN/choose_en"
import FormEN from "./pages_EN/Form_en"
import HardwareEN from "./pages_EN/Hardware_en"
import HardwareHistoryEN from "./pages_EN/HardwareHistory_en"
import SuggestionHealthyEN from "./pages_EN/SuggestionHealthy_en"
import SuggestionHospital2EN from "./pages_EN/SuggestionHospital2_en";



function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="font-face-gr">
          <PrivateRoute exact path="/" component={Home} />
          <Route exact path="/en/" component={HomeEN} />
          <Route exact path="/en/about" component={aboutEN} />
          <Route exact path="/en/choose" component={chooseEN} />
          <Route exact path="/en/Form" component={FormEN} />
          <Route exact path="/en/Hardware" component={HardwareEN} />
          <Route exact path="/en/HardwareHistory" component={HardwareHistoryEN} />
          <Route exact path="/en/SuggestionHealthy" component={SuggestionHealthyEN} />
          <Route exact path="/en/SuggestionHospital2" component={SuggestionHospital2EN} />
          <Route exact path="/login" component={Login} />
          <Route exact path="/signup" component={SignUp} />
          <Route exact path="/upload" component={FileUpload} />
          <Route exact path="/History" component={History} />
          <Route exact path="/Aitest" component={Aitest} />
          <Route exact path="/about" component={About}/>
          <Route exact path="/Brugada" component={Brugada}/>
          <Route exact path="/Hardware" component={Hardware}/>
          <Route exact path="/Read" component={Read}/>
          <Route exact path="/HowtoUse" component={Use}/>
          <Route exact path="/ECGs" component={ECGs}/>
          <Route exact path="/Data1" component={Data1}/>
          <Route exact path="/Data2" component={Data2}/>
          <Route exact path="/Data3" component={Data3}/>
          <Route exact path="/Data4" component={Data4}/>
          <Route exact path="/Form" component={Form}/>
          <Route exact path="/Quiz" component={Quiz}/>
          <Route exact path="/SuggestionHealthy" component={SuggestionHealthy}/>
          <Route exact path="/SuggestionHospital" component={SuggestionHospital}/>
          <Route exact path="/SuggestionHospital2" component={SuggestionHospital2}/>
          <Route exact path="/SuggestionBad" component={SuggestionBad}/>
          <Route exact path="/Telemedicine" component={Telemedicine}/>
          <Route exact path="/HardwareHistory" component={HardwareHistory}/>
          <Route exact path="/HardwareManual" component={HardwareManual}/>
          <Route exact path="/Choose" component={Choose}/>
          <Route exact path="/T1" component={T1}/>
          <Route exact path="/T2" component={T2}/>
          <Route exact path="/T3" component={T3}/>
          <Route exact path="/T4" component={T4}/>
          <Route exact path="/T5" component={T5}/>
          <Route exact path="/T6" component={T6}/>
          <Route exact path="/T7" component={T7}/>
          <Route exact path="/T8" component={T8}/>
          <Route exact path="/T9" component={T9}/>
          <Route exact path="/T10" component={T10}/>
          <Route exact path="/T11" component={T11}/>
          <Route exact path="/T12" component={T12}/>
          <Route exact path="/Telemedicinedemo1" component={Tele}/>
          <Route exact path="/D1" component={D1}/>
          <Route exact path="/demo" component={DateTimePicker}/>
        </div>
      </Router>
    </AuthProvider>
  );
};


export default App;
